import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  showModel:false,
  verifyingPhone: false,
  error: null,
  redirect:false,
};

const otpSlice = createSlice({
  name: 'otp',
  initialState,
  reducers: {
    verifyPhone(state) {
      state.verifyingPhone = true;
    },
    verifyPhoneSuccess(state) {
      state.verifyingPhone = false;
      state.showModel=false;
      state.error = null;
      state.redirect=true;
    },
    verifyPhoneFailure(state, action) {
      state.verifyingPhone = false;
      state.error = action.payload;
    },
    setShowModel(state,action){
      state.showModel=action.payload
    }
  },
});

export const {
  verifyPhone,
  verifyPhoneSuccess,
  verifyPhoneFailure,
  setShowModel,
} = otpSlice.actions;

export default otpSlice.reducer;
